import {
  ListControllerBaseBindings,
  WorkerTimerController,
} from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

class TimerBindings extends ListControllerBaseBindings {
  /** The calculation that the component edits (shows in read-only mode). */
  timerMode = "@";
  /**
   * CRUD controller that typically defines the values for url template and
   */
  public crudController = "<";
}
/**
 * Component for timer usecase
 * @example
 * ```html
 * <salaxy-timer></salaxy-timer>
 * ```
 */
export class Timer extends ComponentBase {
  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = new TimerBindings();

  /** Uses the WorkerTimerController */
  public controller = WorkerTimerController;

  /** The default template for the component. */
  public defaultTemplate =
    "salaxy-components/communications/messages/message-types/Timer.html";
}
